import * as React from 'react';
import { Theme, withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import FaqItem from './FaqItem';
import { localizations } from '../../localization/localization';

const styles = (theme: Theme) => createStyles({
  userCommentsContainer: {
    backgroundColor: '#022639',
    borderTop: `5px solid ${theme.palette.secondary.main}`,
    padding: '2.25em',
    paddingTop: '1.75em',
    paddingBottom: '2.4375em',
    marginTop: '4.375em',
    marginBottom: '4.25em',
  },
  userCommentsContainerMobile: {
    backgroundColor: '#022639',
    maxWidth: 448,
    display: 'flex',
    borderTop: `5px solid ${theme.palette.secondary.main}`,
    paddingTop: '2.0625em',
    paddingBottom: '2.0625em',
    marginBottom: '4.25em',
    paddingLeft: '1em',
    paddingRight: '1em',
  },
  title: {
    fontSize: '2.125em',
    fontWeight: 'bold',
    letterSpacing: '0.0358em',
    lineHeight: 1.353,
    color: 'white'
  },
  userCommentsInnerContainer: {
    display: 'flex',
  },
  userCommentsInnerContainerMobile: {
    display: 'flex',
    alignItems: "center"
  },
  hidden: {
    display: 'none'
  },
  nobull: {
    listStyleType: 'none'
   },
});

interface UserCommentsItemProps {
  content: string;
}

interface UserCommentsContainerProps {
  items: UserCommentsItemProps[];
}

interface MobileViewProps {
  isMobileDevice: boolean | undefined;
}

type Props = MobileViewProps & UserCommentsContainerProps

class UserCommentsContainer extends React.Component<WithStyles & Props, { open: boolean; }> {
  constructor(props: WithStyles & Props) {
    super(props);
  }

  public render() {
    const {
      classes,
      items
    } = this.props;
    return (
      <Grid item container direction="column" alignItems="center" className={this.props.isMobileDevice === false ? classes.userCommentsContainer : classes.userCommentsContainerMobile}>
        <Grid item className={classes.title}>{localizations.landingPageView.userComments.title}</Grid>
          <React.Fragment>
            <Grid item container className={this.props.isMobileDevice === false ? classes.userCommentsInnerContainer : classes.userCommentsInnerContainerMobile}>
                <ul className={classes.nobull}>
              {items.map((item, index) => (
                <li key={`faq_item_${index}`}><p>{item.content}</p></li>
              ))}
              </ul>
            </Grid>
          </React.Fragment>
      </Grid>
    );
  }
}

export default withStyles(styles)(UserCommentsContainer);



// WEBPACK FOOTER //
// ./src/landingPage/components/UserCommentsContainer.tsx